<gb-page-loader [loaded$]="announcementsLoaded$">
  <div>
    <div class="gb-dialog-header">
      <div class="new-chip" translate="NEW"></div>
      <button mat-button mat-dialog-close>
        <gb-icon icon="close" mat-dialog-close></gb-icon>
      </button>
    </div>
    <div class="gb-dialog-content">
      <div class="announcements-list-container">
        <div class="announcements-card-container">
          @if (displayAnnouncement$ | async; as displayAnnouncement) {
            <gb-announcements-card [siteAnnouncement]="displayAnnouncement"></gb-announcements-card>
          }
        </div>
      </div>
    </div>

    <div class="gb-dialog-actions-container">
      <div class="next-announcement-button-container">
        <div>
          @if ((showFinalPage$ | async) === false) {
            <button (click)="showNext()" mat-flat-button translate="NEXT"></button>
          }
          @if (showFinalPage$ | async) {
            <button mat-dialog-close mat-flat-button translate="DONE"></button>
          }
        </div>
      </div>
    </div>
  </div>
</gb-page-loader>
